<template>
	<div id="inside-pre-order-information" class="pre-order-information">
		<h3>
			<slot name="pre_order_or_buy_explanation"></slot>
		</h3>
		<div class="content">
			<slot name="pre_order_bonuses"></slot>
			<slot name="find_out_more">
				<div>
					<slot name="find_out_more_title"></slot>
				</div>
				<div :class="['mbtn', btnCssClass]">
					<slot name="find_out_more_button">
						<a :href="[findOutMoreUrl || '#']">Zjistit více</a>
					</slot>
				</div>
			</slot>
		</div>
	</div>
</template>
<script>
export default {
	name: 'BaseDescription',
	props: {
		findOutMoreUrl: {
			type: String,
			default: '#'
		},
		btnCssClass: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped></style>
